import React, { useEffect, useState } from 'react';
import EventCard from './EventCard';
import moment from 'moment';
import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import { PanelistCard } from '../become-a-coach/Cards';
import useStorage from '../../../utils/hooks/useStorage';

const EventDetail = ({ eventData, eventSlug }) => {
  const [activeItem, setActiveItem] = useState('Quick Selection');
  const [category, setCategory] = useState('');
  const { getItem } = useStorage();
  const currentUtm = getItem('utm') && JSON.parse(getItem('utm'));
  // set query string for redirect
  let queryString = '';
  for (const property in currentUtm) {
    queryString += `&${property}=${currentUtm[property]}`;
  }

  // const eventDataFormatted = getEvent(eventData);
  // const event = {
  //   bgColor: 'blue-7',
  //   title: eventDataFormatted.title,
  //   eventDate: eventDataFormatted.eventDate,
  //   description: eventDataFormatted.description,
  //   startTime: eventDataFormatted.startTime,
  //   endTime: eventDataFormatted.endTime,
  //   eventId: 1,
  //   EventType: eventDataFormatted.EventType,
  //   category: eventDataFormatted.category,
  //   videoLink: eventDataFormatted.videoLink,
  //   eventImage: eventDataFormatted.eventImage,
  //   // registerLink: eventData.registerLink,
  //   regiserCTALink: eventData.registerCTALink,
  // };
  // const start = event.startTime?.split(":");
  // const end = event.endTime?.split(":");
  // const time =
  //   start && start[0] + ":" + start[1] + " - " + end[0] + ":" + end[1];

  useEffect(() => {
    const today = moment(new Date()).format('YYYY-MM-DD');
    const time = moment().format('hh:mm:ss.ssss');
    if (moment(today).isSameOrBefore(eventData.eventDate) && eventData.endTime > time) {
      setCategory('upcoming');
    } else {
      setCategory('past');
    }
  }, [eventData]);

  return (
    <div className="mt-14">
      <EventCard
        {...{
          ...eventData,
          bgColor: 'blue-7',
          eventId: 1,
          eventDate: moment(eventData.eventDate).format('MMMM Do YYYY, dddd'),
        }}
        category={category}
        isWatchVideo={true}
        eventSlug={eventSlug}
      />
      {eventData?.instructor?.data.length > 0 && (
        <h2 className="mx-4 mt-10 text-[36px] lg:mx-0">Panelists</h2>
      )}
      {eventData?.instructor?.data.length > 0 && (
        <div className="grid-flow-rows mx-4 my-5 mb-32 grid grid-cols-2 items-center justify-start gap-4 lg:mx-0 lg:grid-cols-4 lg:gap-8">
          {eventData?.instructor?.data?.map((coach) => (
            <PanelistCard
              key={coach.id}
              name={coach.attributes.Name}
              image={
                coach?.attributes?.DisplayPicture?.data?.attributes?.formats.thumbnail.url ||
                coach?.attributes?.DisplayPicture?.data?.attributes.url
              }
              designation={coach.attributes.Designation}
              company={coach?.attributes?.CompanyImage?.data?.attributes?.url}
              linkedinUrl={coach.attributes.LinkedInUrl}
            />
          ))}
        </div>
      )}
      {eventData.eventAgenda.length > 0 && (
        <h2 className="mb-5 ml-4 text-[36px] lg:ml-0">
          {category === 'upcoming' ? 'What will be discussed' : 'Event Highlights '}
        </h2>
      )}
      {eventData.eventAgenda.map((item) => (
        <div
          key={item.id}
          className="mx-4 rounded-lg border border-red p-4 lg:mx-0 lg:px-8 lg:py-4"
        >
          {/* <div className='font-satoshi-bold font-bold  text-red'>Module 1</div> */}
          <ReactMarkdown
            components={{
              h1: (props) => <h1 {...props} className="mb-4 text-xl" />,
              p: (props) => <p {...props} className="mb-8 text-justify text-base" />,
              a: ({ node, href, children, ...props }) => (
                <a {...props} href={href}>
                  <a className="text-base text-blue hover:underline">{children}</a>
                </a>
              ),
              ul: ({ node, ...props }) => <ul {...props} className="list-inside list-disc" />,
              strong: ({ node, ...props }) => (
                <span {...props} className="font-satoshi-bold text-base font-bold " />
              ),
              li: ({ node, ...props }) => <li {...props} className="text-[16px] lg:text-base" />,
              ol: ({ node, ...props }) => (
                <ol
                  {...props}
                  className="mb-4 list-inside list-decimal font-satoshi-bold font-bold "
                />
              ),
            }}
            // remarkToRehypeOptions={{ allowDangerousHtml: true }}
            // remarkPlugins={[remarkGfm]}
          >
            {item.module}
          </ReactMarkdown>
        </div>
      ))}
      {category === 'upcoming' && (
        <>
          {eventData?.whoShouldaAttend?.length > 0 && (
            <>
              <h2 className="my-10 mb-5 ml-4 lg:ml-0">Who should attend</h2>
              <ul>
                {eventData?.whoShouldaAttend?.map((item) => (
                  <li key={item.id} className="mx-4 text-[16px] lg:mx-0 lg:text-base">
                    - {item.feature}
                  </li>
                ))}
              </ul>
            </>
          )}
          {eventData?.perks?.features?.length > 0 && (
            <>
              <h2 className="my-10 mb-5 ml-4 lg:ml-0">Perks</h2>
              <ul>
                {eventData?.perks?.features?.map((item) => (
                  <li key={item.id} className="mx-4 text-[16px] lg:mx-0 lg:text-base">
                    - {item.feature}
                  </li>
                ))}
              </ul>
              <div className="mx-4 mt-8 mb-10 flex flex-col lg:mx-0 lg:mb-0 lg:flex-row">
                {eventData.perks.images.data.map((item) => (
                  <div key={item.id} className="rounded-md bg-blue-4 p-4 pb-0">
                    <img src={item.attributes.url} alt="" className="lg:h-80 lg:w-80" />
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
      {/* {event.category !== "past" && (
        <div id='register'>
          <BasicForm formType='event' align='items-center'>
            <img
              src={event.eventImage?.data?.attributes?.url}
              alt=''
              className='lg:w-[90%] lg:mr-8 w-full lg:h-full rounded-md mb-8 lg:mb-0 '
            />
          </BasicForm>
        </div>
      )} */}
    </div>
  );
};

export default EventDetail;

// const PanelistCard = ({ panelist }) => {
//   return (
//     <div
//       className={`py-1 bg-blue-4 flex flex-col items-cneter`}
//       style={{ height: "auto", borderRadius: "8px" }}
//     >
//       <ul className='flex flex-col items-center px-6 pt-0 mb-2 text-lg'>
//         <li>
//           <img
//             src={
//               panelist?.attributes?.DisplayPicture?.data?.attributes?.formats
//                 ?.thumbnail.url ||
//               panelist?.attributes?.DisplayPicture?.data?.attributes?.url
//             }
//             alt=''
//             className='h-[136px] rounded-md mt-2'
//           />
//         </li>
//         {console.log(panelist)}
//         <li>
//           <div className='flex flex-col items-center mt-2 w-[10rem]'>
//             <div className='font-satoshi-bold font-bold  text-base text-center capitalize p-0.05'>
//               <span>{panelist?.attributes.Name}</span>
//             </div>
//             <div className='text-red text-xs text-center my-2 capitalize blue-2 p-0.05'>
//               <span>{panelist?.attributes.Designation}</span>
//             </div>
//             <div className='font-satoshi-bold font-bold  text-sm text-gray-5 capitalize p-0.05'>
//               <img
//                 src={
//                   panelist?.attributes?.CompanyImage?.data?.attributes.formats
//                     .thumbnail.url
//                 }
//                 alt=''
//                 className='w-full h-[36px]'
//               />
//             </div>
//             <a
//               className='mt-2'
//               style={{ position: "inherit", float: "right" }}
//               href={panelist?.attributes.linkedInUrl}
//               target='_blank'
//               rel='noreferrer'
//             >
//               <img
//                 src='/assets/icons/courses-icons/LinkedIn@2x.png'
//                 alt=''
//                 className='h-[17px] w-[17px]'
//               />
//             </a>
//           </div>
//         </li>
//       </ul>
//     </div>
//   );
// };

const getEvent = (event) => {
  let today = new Date();
  today = moment(today).format('YYYY-MM-DD');
  let eventData = {};
  let {
    title,
    description,
    eventDate,
    startTime,
    endTime,
    eventImage,
    EventType,
    videoLink,
    registerCTALink,
  } = event;
  const formattedDate = moment(eventDate).format('MMMM Do YYYY, dddd');
  if (moment(today).isSameOrBefore(eventDate)) {
    eventData = {
      title,
      description,
      eventDate: formattedDate,
      startTime,
      endTime,
      eventId: event.id,
      EventType,
      category: 'upcoming',
      eventImage,
      registerCTALink,
    };
  } else {
    eventData = {
      title,
      description,
      eventDate: formattedDate,
      startTime,
      endTime,
      eventId: event.id,
      EventType,
      category: 'past',
      videoLink,
      eventImage,
    };
  }
  return eventData;
};
